export enum BuilderRightEnum {
  Sessions = 'Sessions',
  Schema = 'Schema',
  Validation = 'Validation',
  File = 'File'
}
